import script from "./productlist.vue?vue&type=script&setup=true&lang=js"
export * from "./productlist.vue?vue&type=script&setup=true&lang=js"

import "./productlist.vue?vue&type=style&index=0&id=1a874b8d&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a874b8d"]])

export default __exports__